import React from "react";
import { languages, countries } from "./types";


const LanguageContext = React.createContext<[languages, (newValue: languages) => void]>(["en", (x) => x]);
const TokenContext = React.createContext<[string | null, (newValue: string | null) => void]>([null, (x) => x]);
const CountryContext = React.createContext<[countries | undefined, (newValue: countries) => void]>(["sa", (x) => x]);

export { LanguageContext, CountryContext, TokenContext }